module.exports = __webpack_public_path__ + "img/cn.c7cee5e9.svg";